import type { Dispatch } from 'redux';
import { SET_CAPTCHA_RESPONSE } from '../../../constants';

type DispatchAction = Dispatch<{ type: string; payload?: unknown }>;

export const setCaptchaResponse =
  (response: string) => (dispatch: DispatchAction) => {
    return dispatch({ type: SET_CAPTCHA_RESPONSE, payload: { response } });
  };
